import config from "../../app.json";
import axios from "axios";

import "react-toggle/style.css";
import FieldText from "../Fields/FieldText";
import { Button, Row, Col } from "react-bootstrap";
import AlertComponent from "../AlertComponent";
import React, { useEffect } from "react";

function AddOrEditRmtpInput(props) {
  const {
    inputName,
    instanceName,
    setInstanceName,
    applicationName,
    setApplicationName,
    rtmpLink,
    setRtmpLink,
    handleAddNewElementsInput,
    currentElement,
  } = props;

  useEffect(() => {
    if (!currentElement) {
      return;
    }

    setApplicationName(currentElement.applicationName);
    setInstanceName(currentElement.instanceName);
    setRtmpLink(currentElement.rtmpLink);
  }, [currentElement]);

  const handleAddItem = () => {
    if (!inputName) {
      return AlertComponent("Error", "Input name is required", {
        icon: `error`,
      });
    }

    if (!applicationName) {
      return AlertComponent("Error", "Application name is required", {
        icon: `error`,
      });
    }

    if (!instanceName) {
      return AlertComponent("Error", "Instance name is required", {
        icon: `error`,
      });
    }

    let item = {
      name: inputName,
      applicationName: applicationName,
      instanceName: instanceName,
    };

    if (currentElement) {
      item.id = currentElement.id;
    }

    axios
      .post(config.API + "/api/Input/saveInputRTMP", item)
      .then((res) => {
        if (res.status === 200 && res.data) {
          const newInput = { ...res.data };
          delete newInput.$id;
          handleAddNewElementsInput(newInput);
          return AlertComponent("Success", "Input has been saved successfully");
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  return (
    <div>
      <Row>
        <Col md={12}>
          <FieldText
            label="Enter Application Name"
            type="text"
            onChange={(x) => setApplicationName(x.target.value)}
            placeholder="Give your application a name"
            value={applicationName}
            required={true}
            inputClassName={`inputOption`}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FieldText
            label="Enter Instance Name"
            type="text"
            onChange={(x) => setInstanceName(x.target.value)}
            placeholder="Give your instance a name"
            value={instanceName}
            required={true}
            inputClassName={`inputOption`}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          {currentElement &&
            <FieldText
              label="Your RTMP Push Link"
              type="text"
              placeholder="rtmp://00.000.000.000:1935/pray-application/pray-instance"
              value={rtmpLink}
              readonly={true}
              inputClassName={`inputOption`}
            />
          }
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className="d-flex justify-content-end pt-2">
            <Button className="dark-btn" onClick={handleAddItem}>{`${!currentElement ? `Add` : `Update`
              } RTMP Input`}</Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default AddOrEditRmtpInput;
